import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

/** audit log entry */
export type AuditLog = {
  __typename?: 'AuditLog';
  _id: Scalars['String'];
  action: Scalars['String'];
  changes?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  entityName?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  siteId?: Maybe<Scalars['String']>;
  versionNumber?: Maybe<Scalars['Float']>;
};

export type AuditLogFilterInput = {
  action?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['String']>;
};

export type BannerImage = {
  __typename?: 'BannerImage';
  alt?: Maybe<Scalars['String']>;
  lg?: Maybe<Scalars['String']>;
  md?: Maybe<Scalars['String']>;
  sm?: Maybe<Scalars['String']>;
};

export type BannerImageInput = {
  alt?: InputMaybe<Scalars['String']>;
  lg?: InputMaybe<Scalars['String']>;
  md?: InputMaybe<Scalars['String']>;
  sm?: InputMaybe<Scalars['String']>;
};

/** url data structure */
export type CategoryWp = {
  __typename?: 'CategoryWP';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** client entity */
export type Client = {
  __typename?: 'Client';
  _id: Scalars['String'];
  bannerTitleWhite?: Maybe<Scalars['Boolean']>;
  blog_cta?: Maybe<Scalars['Boolean']>;
  contact?: Maybe<Contact>;
  contact_form: Scalars['Boolean'];
  contact_page?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  favicon?: Maybe<Favicon>;
  footer_text?: Maybe<Scalars['String']>;
  gtm?: Maybe<Scalars['String']>;
  logo?: Maybe<Image>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  portal?: Maybe<Scalars['Boolean']>;
  registeredName: Scalars['String'];
  registered_number?: Maybe<Scalars['String']>;
  social?: Maybe<Social>;
  socialImage?: Maybe<Image>;
  team_basic: Scalars['Boolean'];
  team_modal: Scalars['Boolean'];
};

/** client entity */
export type ClientInput = {
  bannerTitleWhite?: InputMaybe<Scalars['Boolean']>;
  blog_cta?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<ContactInput>;
  contact_form: Scalars['Boolean'];
  contact_page?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  favicon?: InputMaybe<FaviconInput>;
  footer_text?: InputMaybe<Scalars['String']>;
  gtm?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<ImageInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  portal?: InputMaybe<Scalars['Boolean']>;
  registeredName: Scalars['String'];
  registered_number?: InputMaybe<Scalars['String']>;
  social?: InputMaybe<SocialInput>;
  socialImage?: InputMaybe<ImageInput>;
  team_basic: Scalars['Boolean'];
  team_modal: Scalars['Boolean'];
};

/** contact data structure */
export type Contact = {
  __typename?: 'Contact';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
};

export type Content = {
  __typename?: 'Content';
  bannerImage?: Maybe<BannerImage>;
  bannerTitleWhite?: Maybe<Scalars['Boolean']>;
  layout: Scalars['String'];
  main: Region;
  removeBackground?: Maybe<Scalars['Boolean']>;
  sidebar?: Maybe<Region>;
  tagline: Scalars['String'];
  title: Scalars['String'];
};

export type ContentInput = {
  bannerImage?: InputMaybe<BannerImageInput>;
  bannerTitleWhite?: InputMaybe<Scalars['Boolean']>;
  layout: Scalars['String'];
  main: RegionInput;
  removeBackground?: InputMaybe<Scalars['Boolean']>;
  sidebar?: InputMaybe<RegionInput>;
  tagline: Scalars['String'];
  title: Scalars['String'];
};

export type CreateDomainInput = {
  domain: Scalars['String'];
  redirectWww?: Scalars['Boolean'];
};

export type DigestResult = {
  __typename?: 'DigestResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Domain with managed ACM certificate */
export type Domain = {
  __typename?: 'Domain';
  _id: Scalars['String'];
  certificateArn: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  lastCheckedAt?: Maybe<Scalars['DateTime']>;
  ownsCert: Scalars['Boolean'];
  redirectWww: Scalars['Boolean'];
  status: DomainStatus;
  statusError?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validationRecords: Array<DomainValidationRecord>;
};

export enum DomainStatus {
  Failed = 'FAILED',
  Issued = 'ISSUED',
  Pending = 'PENDING'
}

export type DomainValidationRecord = {
  __typename?: 'DomainValidationRecord';
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

/** favicon data structure */
export type Favicon = {
  __typename?: 'Favicon';
  s16?: Maybe<Scalars['String']>;
  s32?: Maybe<Scalars['String']>;
  s180?: Maybe<Scalars['String']>;
  s192?: Maybe<Scalars['String']>;
  s512?: Maybe<Scalars['String']>;
};

export type FaviconInput = {
  s16?: InputMaybe<Scalars['String']>;
  s32?: InputMaybe<Scalars['String']>;
  s180?: InputMaybe<Scalars['String']>;
  s192?: InputMaybe<Scalars['String']>;
  s512?: InputMaybe<Scalars['String']>;
};

/** url data structure */
export type Image = {
  __typename?: 'Image';
  src: Scalars['String'];
};

export type ImageInput = {
  src: Scalars['String'];
};

export type InviteUserInput = {
  email: Scalars['String'];
  role: UserRole;
  siteIds: Array<Scalars['String']>;
};

export type LinkWp = {
  __typename?: 'LinkWP';
  id: Scalars['String'];
  menu_order?: Maybe<Scalars['Float']>;
  publish_status: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type MenuWp = {
  __typename?: 'MenuWP';
  id: Scalars['String'];
  links: Array<LinkWp>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: Scalars['Boolean'];
  createClient: Client;
  createDomain: Domain;
  createPartnerPage: PartnerPage;
  createProfile: Profile;
  createSite: Site;
  deactivateUser: User;
  deleteDomain: Scalars['Boolean'];
  deletePartnerPage: PartnerPage;
  deleteProfile: Profile;
  deleteSite: Site;
  deleteUser: User;
  inviteUser: User;
  reactivateUser: User;
  refreshDomainStatus: Domain;
  reorderProfiles: Array<Profile>;
  requestPasswordReset: Scalars['Boolean'];
  resendInvite: User;
  revertPartnerPage: PartnerPage;
  sendDailyDigest: DigestResult;
  toggleDailyDigest: User;
  updatePartnerPage: PartnerPage;
  updateProfile: Profile;
  updateSite: Site;
  updateSiteNavigation: Site;
  updateSiteRedirects: Site;
  updateUserRole: User;
};


export type MutationAcceptInviteArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCreateClientArgs = {
  createClientInput: ClientInput;
};


export type MutationCreateDomainArgs = {
  input: CreateDomainInput;
};


export type MutationCreatePartnerPageArgs = {
  createPartnerPageInput: PartnerPageInput;
};


export type MutationCreateProfileArgs = {
  createProfileInput: ProfileInput;
};


export type MutationCreateSiteArgs = {
  createSiteInput: SiteInput;
};


export type MutationDeactivateUserArgs = {
  userId: Scalars['String'];
};


export type MutationDeleteDomainArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePartnerPageArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProfileArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSiteArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String'];
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationReactivateUserArgs = {
  userId: Scalars['String'];
};


export type MutationRefreshDomainStatusArgs = {
  id: Scalars['ID'];
};


export type MutationReorderProfilesArgs = {
  input: Array<ReorderProfileInput>;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationResendInviteArgs = {
  userId: Scalars['String'];
};


export type MutationRevertPartnerPageArgs = {
  id: Scalars['String'];
  versionNumber: Scalars['Int'];
};


export type MutationSendDailyDigestArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type MutationToggleDailyDigestArgs = {
  receive: Scalars['Boolean'];
  userId: Scalars['String'];
};


export type MutationUpdatePartnerPageArgs = {
  id: Scalars['String'];
  updatePartnerPageInput: PartnerPageInput;
};


export type MutationUpdateProfileArgs = {
  id: Scalars['String'];
  updateProfileInput: ProfileInput;
};


export type MutationUpdateSiteArgs = {
  id: Scalars['String'];
  updateSiteInput: SiteInput;
};


export type MutationUpdateSiteNavigationArgs = {
  navigation: NavigationInput;
  siteId: Scalars['String'];
};


export type MutationUpdateSiteRedirectsArgs = {
  redirects: Array<UrlRedirectInput>;
  siteId: Scalars['String'];
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

/** navigation item */
export type NavItem = {
  __typename?: 'NavItem';
  children?: Maybe<Array<NavItem>>;
  id: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Float'];
  pageId?: Maybe<Scalars['String']>;
  redirectToChild?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type NavItemInput = {
  children?: InputMaybe<Array<NavItemInput>>;
  id: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Float'];
  pageId?: InputMaybe<Scalars['String']>;
  redirectToChild?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

/** site navigation */
export type Navigation = {
  __typename?: 'Navigation';
  footer?: Maybe<Array<NavItem>>;
  header?: Maybe<Array<NavItem>>;
};

export type NavigationInput = {
  footer?: InputMaybe<Array<NavItemInput>>;
  header?: InputMaybe<Array<NavItemInput>>;
};

export type Page = {
  __typename?: 'Page';
  content: Scalars['String'];
  content_blocks?: Maybe<Scalars['JSON']>;
  date: Scalars['String'];
  excerpt: Scalars['String'];
  header_image?: Maybe<Scalars['String']>;
  header_text: Scalars['String'];
  id: Scalars['String'];
  modified: Scalars['String'];
  portal_content?: Maybe<Scalars['JSON']>;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  uri: Scalars['String'];
  url: Scalars['String'];
};

/** page entity */
export type PartnerPage = {
  __typename?: 'PartnerPage';
  _id: Scalars['String'];
  articleDate?: Maybe<Scalars['DateTime']>;
  author?: Maybe<Scalars['String']>;
  authorTitle?: Maybe<Scalars['String']>;
  byline?: Maybe<Scalars['String']>;
  content: Content;
  deleted: Scalars['Boolean'];
  description: Scalars['String'];
  hidden?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  pages: Array<PartnerPage>;
  policy?: Maybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  redirectToChild?: Maybe<Scalars['Boolean']>;
  seoTitle?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  thumbnail?: Maybe<BannerImage>;
  title: Scalars['String'];
  type: Scalars['String'];
};

/** partner page entity */
export type PartnerPageInput = {
  articleDate?: InputMaybe<Scalars['DateTime']>;
  author?: InputMaybe<Scalars['String']>;
  authorTitle?: InputMaybe<Scalars['String']>;
  byline?: InputMaybe<Scalars['String']>;
  content: ContentInput;
  description: Scalars['String'];
  hidden?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
  pages?: InputMaybe<Array<Scalars['String']>>;
  policy?: InputMaybe<Scalars['Boolean']>;
  published: Scalars['Boolean'];
  redirectToChild?: InputMaybe<Scalars['Boolean']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  site: Scalars['String'];
  slug: Scalars['String'];
  thumbnail?: InputMaybe<BannerImageInput>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

/** partner page version snapshot */
export type PartnerPageVersion = {
  __typename?: 'PartnerPageVersion';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  pageId: Scalars['String'];
  siteId?: Maybe<Scalars['String']>;
  snapshot: Scalars['JSON'];
  versionNumber: Scalars['Float'];
};

export type PostWp = {
  __typename?: 'PostWP';
  acf?: Maybe<Scalars['JSON']>;
  author_1?: Maybe<ProfileWp>;
  author_2?: Maybe<ProfileWp>;
  author_location?: Maybe<Scalars['String']>;
  byline?: Maybe<Scalars['String']>;
  categories: Array<CategoryWp>;
  content_blocks?: Maybe<Scalars['JSON']>;
  cro_cta?: Maybe<Scalars['String']>;
  curo_source?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  excerpt: Scalars['String'];
  featured_image?: Maybe<Image>;
  hide_disclaimer: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  link: Scalars['String'];
  reviewed_by?: Maybe<ProfileWp>;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri: Scalars['String'];
  url: Scalars['String'];
};

/** profile entity */
export type Profile = {
  __typename?: 'Profile';
  _id: Scalars['String'];
  contact?: Maybe<Contact>;
  deleted: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  site?: Maybe<Site>;
  social?: Maybe<Social>;
  surname?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title: Scalars['String'];
};

/** profile entity input data structure */
export type ProfileInput = {
  contact?: InputMaybe<ContactInput>;
  firstName?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<ImageInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  site: Scalars['String'];
  social?: InputMaybe<SocialInput>;
  surname?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type ProfileWp = {
  __typename?: 'ProfileWP';
  job_title?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Image>;
  title: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  allUsers: Array<User>;
  auditLogs: Array<AuditLog>;
  auditLogsByEntity: Array<AuditLog>;
  auditLogsBySite: Array<AuditLog>;
  client: Client;
  clients: Array<Client>;
  domains: Array<Domain>;
  domainsIssued: Array<Domain>;
  getProfileById: Profile;
  me: User;
  page: Page;
  partnerPage: PartnerPage;
  partnerPageVersion: PartnerPageVersion;
  partnerPageVersions: Array<PartnerPageVersion>;
  partnerPages: Array<PartnerPage>;
  post: PostWp;
  profiles: Array<Profile>;
  site: Site;
  siteIpAddress?: Maybe<Scalars['String']>;
  sites: Array<Site>;
  users: Array<User>;
};


export type QueryAuditLogsArgs = {
  filter?: InputMaybe<AuditLogFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAuditLogsByEntityArgs = {
  entityId: Scalars['String'];
  entityType: Scalars['String'];
};


export type QueryAuditLogsBySiteArgs = {
  siteId: Scalars['String'];
};


export type QueryClientArgs = {
  id: Scalars['String'];
};


export type QueryGetProfileByIdArgs = {
  id: Scalars['String'];
};


export type QueryPageArgs = {
  url: Scalars['String'];
};


export type QueryPartnerPageArgs = {
  id: Scalars['String'];
};


export type QueryPartnerPageVersionArgs = {
  pageId: Scalars['String'];
  versionNumber: Scalars['Int'];
};


export type QueryPartnerPageVersionsArgs = {
  pageId: Scalars['String'];
};


export type QueryPartnerPagesArgs = {
  siteId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryPostArgs = {
  slug: Scalars['String'];
};


export type QueryProfilesArgs = {
  siteId?: InputMaybe<Scalars['String']>;
};


export type QuerySiteArgs = {
  categoryId: Scalars['String'];
  url: Scalars['String'];
};


export type QueryUsersArgs = {
  siteId: Scalars['String'];
};

export type Region = {
  __typename?: 'Region';
  blocks: Array<Scalars['JSON']>;
};

export type RegionInput = {
  blocks: Array<Scalars['JSON']>;
};

/** reorder profile input */
export type ReorderProfileInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type Section = {
  __typename?: 'Section';
  sidenav?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SettingWp = {
  __typename?: 'SettingWP';
  article_sources_text?: Maybe<Scalars['String']>;
  article_sources_title?: Maybe<Scalars['String']>;
  consolidating_pension?: Maybe<Section>;
  default?: Maybe<Section>;
  disclaimer_financial_planning_journal?: Maybe<Scalars['String']>;
  disclaimer_investors_digest?: Maybe<Scalars['String']>;
  financial_planning?: Maybe<Section>;
  inheritance_tax?: Maybe<Section>;
  investing?: Maybe<Section>;
  life_events?: Maybe<Section>;
  pensions?: Maybe<Section>;
  protection?: Maybe<Section>;
  retirement_planning?: Maybe<Section>;
  tax_planning?: Maybe<Section>;
  wealth_management?: Maybe<Section>;
};

/** site entity */
export type Site = {
  __typename?: 'Site';
  _id: Scalars['String'];
  client?: Maybe<Client>;
  domain?: Maybe<Domain>;
  domainId?: Maybe<Scalars['String']>;
  menus: Array<MenuWp>;
  navigation?: Maybe<Navigation>;
  partnerPages?: Maybe<Array<PartnerPage>>;
  posts: Array<PostWp>;
  redirects?: Maybe<Array<UrlRedirect>>;
  team: Array<Profile>;
  url: Scalars['String'];
  wp_settings: SettingWp;
};


/** site entity */
export type SitePostsArgs = {
  categoryId: Scalars['String'];
  limit: Scalars['Float'];
  startAt: Scalars['Float'];
};

export type SiteInput = {
  client: ClientInput;
  domainId?: InputMaybe<Scalars['String']>;
  navigation?: InputMaybe<NavigationInput>;
  partnerPages?: InputMaybe<Array<Scalars['String']>>;
  redirects?: InputMaybe<Array<UrlRedirectInput>>;
  team?: InputMaybe<Array<Scalars['String']>>;
  url?: InputMaybe<Scalars['String']>;
};

/** contact data structure */
export type Social = {
  __typename?: 'Social';
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  linkedIn?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type SocialInput = {
  facebook?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export type UpdateUserRoleInput = {
  role: UserRole;
  userId: Scalars['String'];
};

/** url redirect entry */
export type UrlRedirect = {
  __typename?: 'UrlRedirect';
  createdAt: Scalars['DateTime'];
  from: Scalars['String'];
  to: Scalars['String'];
};

export type UrlRedirectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  from: Scalars['String'];
  to: Scalars['String'];
};

/** Platform user (mapped from AWS Cognito) */
export type User = {
  __typename?: 'User';
  _id: Scalars['String'];
  cognitoSub: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  receiveDailyDigest: Scalars['Boolean'];
  role: UserRole;
  siteIds: Array<Scalars['String']>;
  status: UserStatus;
  updatedAt: Scalars['DateTime'];
};

export enum UserRole {
  PlatformAdmin = 'PLATFORM_ADMIN',
  SiteAdmin = 'SITE_ADMIN',
  SiteMember = 'SITE_MEMBER'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Invited = 'INVITED'
}

export type AcceptInviteMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite: boolean };

export type ClientFragment = { __typename?: 'Client', name: string, registeredName: string, registered_number?: string | null, email?: string | null, phone?: string | null, contact_page?: string | null, contact_form: boolean, blog_cta?: boolean | null, portal?: boolean | null, team_modal: boolean, team_basic: boolean, footer_text?: string | null, gtm?: string | null, bannerTitleWhite?: boolean | null, contact?: { __typename?: 'Contact', line1: string, line2?: string | null, city?: string | null, county?: string | null, postcode?: string | null, country?: string | null } | null, logo?: { __typename?: 'Image', src: string } | null, favicon?: { __typename?: 'Favicon', s16?: string | null, s32?: string | null, s180?: string | null, s192?: string | null, s512?: string | null } | null, socialImage?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null };

export type CreateDomainMutationVariables = Exact<{
  input: CreateDomainInput;
}>;


export type CreateDomainMutation = { __typename?: 'Mutation', createDomain: { __typename?: 'Domain', _id: string, domain: string, redirectWww: boolean, certificateArn: string, ownsCert: boolean, status: DomainStatus, statusError?: string | null, lastCheckedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, validationRecords: Array<{ __typename?: 'DomainValidationRecord', name: string, value: string, type: string }> } };

export type CreatePartnerPageMutationVariables = Exact<{
  createPartnerPageInput: PartnerPageInput;
}>;


export type CreatePartnerPageMutation = { __typename?: 'Mutation', createPartnerPage: { __typename?: 'PartnerPage', _id: string, description: string, name: string, published: boolean, slug: string, order?: number | null, title: string, seoTitle?: string | null, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, content: { __typename?: 'Content', layout: string, title: string, tagline: string, bannerImage?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, main: { __typename?: 'Region', blocks: Array<any> }, sidebar?: { __typename?: 'Region', blocks: Array<any> } | null } } };

export type CreateProfileMutationVariables = Exact<{
  createProfileInput: ProfileInput;
}>;


export type CreateProfileMutation = { __typename?: 'Mutation', createProfile: { __typename?: 'Profile', _id: string, name: string, title: string, text: string, order?: number | null, image?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } };

export type CreateSiteMutationVariables = Exact<{
  createSiteInput: SiteInput;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite: { __typename?: 'Site', _id: string, url: string, client?: { __typename?: 'Client', name: string, registeredName: string, registered_number?: string | null, email?: string | null, phone?: string | null, contact_page?: string | null, contact_form: boolean, blog_cta?: boolean | null, portal?: boolean | null, team_modal: boolean, team_basic: boolean, footer_text?: string | null, gtm?: string | null, bannerTitleWhite?: boolean | null, contact?: { __typename?: 'Contact', line1: string, line2?: string | null, city?: string | null, county?: string | null, postcode?: string | null, country?: string | null } | null, logo?: { __typename?: 'Image', src: string } | null, favicon?: { __typename?: 'Favicon', s16?: string | null, s32?: string | null, s180?: string | null, s192?: string | null, s512?: string | null } | null, socialImage?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } | null } };

export type DeactivateUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string } };

export type DeleteDomainMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDomainMutation = { __typename?: 'Mutation', deleteDomain: boolean };

export type DeletePartnerPageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePartnerPageMutation = { __typename?: 'Mutation', deletePartnerPage: { __typename?: 'PartnerPage', _id: string } };

export type DeleteProfileMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProfileMutation = { __typename?: 'Mutation', deleteProfile: { __typename?: 'Profile', _id: string } };

export type DeleteSiteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite: { __typename?: 'Site', _id: string, url: string, client?: { __typename?: 'Client', name: string, registeredName: string, registered_number?: string | null, email?: string | null, phone?: string | null, contact_page?: string | null, contact_form: boolean, blog_cta?: boolean | null, portal?: boolean | null, team_modal: boolean, team_basic: boolean, footer_text?: string | null, gtm?: string | null, bannerTitleWhite?: boolean | null, contact?: { __typename?: 'Contact', line1: string, line2?: string | null, city?: string | null, county?: string | null, postcode?: string | null, country?: string | null } | null, logo?: { __typename?: 'Image', src: string } | null, favicon?: { __typename?: 'Favicon', s16?: string | null, s32?: string | null, s180?: string | null, s192?: string | null, s512?: string | null } | null, socialImage?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } | null } };

export type DomainFragment = { __typename?: 'Domain', _id: string, domain: string, redirectWww: boolean, certificateArn: string, ownsCert: boolean, status: DomainStatus, statusError?: string | null, lastCheckedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, validationRecords: Array<{ __typename?: 'DomainValidationRecord', name: string, value: string, type: string }> };

export type DomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainsQuery = { __typename?: 'Query', domains: Array<{ __typename?: 'Domain', _id: string, domain: string, redirectWww: boolean, certificateArn: string, ownsCert: boolean, status: DomainStatus, statusError?: string | null, lastCheckedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, validationRecords: Array<{ __typename?: 'DomainValidationRecord', name: string, value: string, type: string }> }> };

export type DomainsIssuedQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainsIssuedQuery = { __typename?: 'Query', domainsIssued: Array<{ __typename?: 'Domain', _id: string, domain: string, redirectWww: boolean, certificateArn: string, ownsCert: boolean, status: DomainStatus, statusError?: string | null, lastCheckedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, validationRecords: Array<{ __typename?: 'DomainValidationRecord', name: string, value: string, type: string }> }> };

export type GetArticleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetArticleQuery = { __typename?: 'Query', partnerPage: { __typename?: 'PartnerPage', _id: string, name: string, title: string, description: string, slug: string, published: boolean, author?: string | null, authorTitle?: string | null, articleDate?: string | null, seoTitle?: string | null, byline?: string | null, type: string, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, content: { __typename?: 'Content', layout: string, title: string, tagline: string, main: { __typename?: 'Region', blocks: Array<any> } } } };

export type GetArticlesQueryVariables = Exact<{
  siteId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}>;


export type GetArticlesQuery = { __typename?: 'Query', partnerPages: Array<{ __typename?: 'PartnerPage', _id: string, name: string, title: string, slug: string, published: boolean, author?: string | null, articleDate?: string | null, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null }> };

export type GetPartnerPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPartnerPageQuery = { __typename?: 'Query', partnerPage: { __typename?: 'PartnerPage', _id: string, name: string, title: string, seoTitle?: string | null, description: string, slug: string, published: boolean, policy?: boolean | null, hidden?: boolean | null, redirectToChild?: boolean | null, type: string, author?: string | null, articleDate?: string | null, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, content: { __typename?: 'Content', layout: string, title: string, tagline: string, bannerImage?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, main: { __typename?: 'Region', blocks: Array<any> }, sidebar?: { __typename?: 'Region', blocks: Array<any> } | null } } };

export type GetPartnerPageVersionsQueryVariables = Exact<{
  pageId: Scalars['String'];
}>;


export type GetPartnerPageVersionsQuery = { __typename?: 'Query', partnerPageVersions: Array<{ __typename?: 'PartnerPageVersion', _id: string, pageId: string, versionNumber: number, snapshot: any, note?: string | null, createdAt: string }> };

export type GetPartnerPagesQueryVariables = Exact<{
  siteId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}>;


export type GetPartnerPagesQuery = { __typename?: 'Query', partnerPages: Array<{ __typename?: 'PartnerPage', _id: string, name: string, title: string, slug: string, published: boolean, policy?: boolean | null, hidden?: boolean | null, type: string, author?: string | null, articleDate?: string | null }> };

export type GetProfileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProfileQuery = { __typename?: 'Query', getProfileById: { __typename?: 'Profile', _id: string, name: string, firstName?: string | null, surname?: string | null, title: string, text: string, order?: number | null, image?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } };

export type GetProfilesQueryVariables = Exact<{
  siteId: Scalars['String'];
}>;


export type GetProfilesQuery = { __typename?: 'Query', profiles: Array<{ __typename?: 'Profile', _id: string, name: string, firstName?: string | null, surname?: string | null, title: string, text: string, order?: number | null, image?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null }> };

export type GetSiteQueryVariables = Exact<{
  url: Scalars['String'];
  categoryId: Scalars['String'];
}>;


export type GetSiteQuery = { __typename?: 'Query', site: { __typename?: 'Site', _id: string, url: string, client?: { __typename?: 'Client', name: string, registeredName: string, registered_number?: string | null, email?: string | null, phone?: string | null, contact_page?: string | null, contact_form: boolean, blog_cta?: boolean | null, portal?: boolean | null, team_modal: boolean, team_basic: boolean, footer_text?: string | null, gtm?: string | null, bannerTitleWhite?: boolean | null, contact?: { __typename?: 'Contact', line1: string, line2?: string | null, city?: string | null, county?: string | null, postcode?: string | null, country?: string | null } | null, logo?: { __typename?: 'Image', src: string } | null, favicon?: { __typename?: 'Favicon', s16?: string | null, s32?: string | null, s180?: string | null, s192?: string | null, s512?: string | null } | null, socialImage?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } | null, menus: Array<{ __typename?: 'MenuWP', id: string, name: string, slug: string, links: Array<{ __typename?: 'LinkWP', title: string, slug: string, menu_order?: number | null }> }> } };

export type GetSiteNavigationQueryVariables = Exact<{
  url: Scalars['String'];
  categoryId: Scalars['String'];
}>;


export type GetSiteNavigationQuery = { __typename?: 'Query', site: { __typename?: 'Site', _id: string, url: string, menus: Array<{ __typename?: 'MenuWP', id: string, name: string, slug: string, links: Array<{ __typename?: 'LinkWP', title: string, slug: string, url: string }> }>, navigation?: { __typename?: 'Navigation', header?: Array<{ __typename?: 'NavItem', id: string, label: string, type: string, pageId?: string | null, url?: string | null, order: number, redirectToChild?: boolean | null, children?: Array<{ __typename?: 'NavItem', id: string, label: string, type: string, pageId?: string | null, url?: string | null, order: number, redirectToChild?: boolean | null }> | null }> | null, footer?: Array<{ __typename?: 'NavItem', id: string, label: string, type: string, pageId?: string | null, url?: string | null, order: number, redirectToChild?: boolean | null }> | null } | null, redirects?: Array<{ __typename?: 'UrlRedirect', from: string, to: string, createdAt: string }> | null } };

export type GetSiteRedirectsQueryVariables = Exact<{
  url: Scalars['String'];
  categoryId: Scalars['String'];
}>;


export type GetSiteRedirectsQuery = { __typename?: 'Query', site: { __typename?: 'Site', _id: string, redirects?: Array<{ __typename?: 'UrlRedirect', from: string, to: string, createdAt: string }> | null } };

export type GetSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', _id: string, url: string, domainId?: string | null, client?: { __typename?: 'Client', name: string, registeredName: string, registered_number?: string | null, email?: string | null, phone?: string | null, contact_page?: string | null, contact_form: boolean, blog_cta?: boolean | null, portal?: boolean | null, team_modal: boolean, team_basic: boolean, footer_text?: string | null, gtm?: string | null, bannerTitleWhite?: boolean | null, contact?: { __typename?: 'Contact', line1: string, line2?: string | null, city?: string | null, county?: string | null, postcode?: string | null, country?: string | null } | null, logo?: { __typename?: 'Image', src: string } | null, favicon?: { __typename?: 'Favicon', s16?: string | null, s32?: string | null, s180?: string | null, s192?: string | null, s512?: string | null } | null, socialImage?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } | null }> };

export type GetUsersQueryVariables = Exact<{
  siteId: Scalars['String'];
}>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string }> };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string } };

export type PartnerPageFragment = { __typename?: 'PartnerPage', _id: string, description: string, name: string, published: boolean, slug: string, order?: number | null, title: string, seoTitle?: string | null, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, content: { __typename?: 'Content', layout: string, title: string, tagline: string, bannerImage?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, main: { __typename?: 'Region', blocks: Array<any> }, sidebar?: { __typename?: 'Region', blocks: Array<any> } | null } };

export type RefreshDomainStatusMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshDomainStatusMutation = { __typename?: 'Mutation', refreshDomainStatus: { __typename?: 'Domain', _id: string, domain: string, redirectWww: boolean, certificateArn: string, ownsCert: boolean, status: DomainStatus, statusError?: string | null, lastCheckedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, validationRecords: Array<{ __typename?: 'DomainValidationRecord', name: string, value: string, type: string }> } };

export type ReorderProfilesMutationVariables = Exact<{
  input: Array<ReorderProfileInput> | ReorderProfileInput;
}>;


export type ReorderProfilesMutation = { __typename?: 'Mutation', reorderProfiles: Array<{ __typename?: 'Profile', _id: string, order?: number | null }> };

export type ResendInviteMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite: { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string } };

export type RevertPartnerPageMutationVariables = Exact<{
  id: Scalars['String'];
  versionNumber: Scalars['Int'];
}>;


export type RevertPartnerPageMutation = { __typename?: 'Mutation', revertPartnerPage: { __typename?: 'PartnerPage', _id: string, description: string, name: string, published: boolean, slug: string, order?: number | null, title: string, seoTitle?: string | null, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, content: { __typename?: 'Content', layout: string, title: string, tagline: string, bannerImage?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, main: { __typename?: 'Region', blocks: Array<any> }, sidebar?: { __typename?: 'Region', blocks: Array<any> } | null } } };

export type ToggleDailyDigestMutationVariables = Exact<{
  userId: Scalars['String'];
  receive: Scalars['Boolean'];
}>;


export type ToggleDailyDigestMutation = { __typename?: 'Mutation', toggleDailyDigest: { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string } };

export type UpdatePartnerPageMutationVariables = Exact<{
  id: Scalars['String'];
  updatePartnerPageInput: PartnerPageInput;
}>;


export type UpdatePartnerPageMutation = { __typename?: 'Mutation', updatePartnerPage: { __typename?: 'PartnerPage', _id: string, description: string, name: string, published: boolean, slug: string, order?: number | null, title: string, seoTitle?: string | null, thumbnail?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, content: { __typename?: 'Content', layout: string, title: string, tagline: string, bannerImage?: { __typename?: 'BannerImage', lg?: string | null, md?: string | null, sm?: string | null, alt?: string | null } | null, main: { __typename?: 'Region', blocks: Array<any> }, sidebar?: { __typename?: 'Region', blocks: Array<any> } | null } } };

export type UpdateProfileMutationVariables = Exact<{
  id: Scalars['String'];
  updateProfileInput: ProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', _id: string, name: string, title: string, text: string, order?: number | null, image?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } };

export type UpdateSiteMutationVariables = Exact<{
  id: Scalars['String'];
  updateSiteInput: SiteInput;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite: { __typename?: 'Site', _id: string, url: string, client?: { __typename?: 'Client', name: string, registeredName: string, registered_number?: string | null, email?: string | null, phone?: string | null, contact_page?: string | null, contact_form: boolean, blog_cta?: boolean | null, portal?: boolean | null, team_modal: boolean, team_basic: boolean, footer_text?: string | null, gtm?: string | null, bannerTitleWhite?: boolean | null, contact?: { __typename?: 'Contact', line1: string, line2?: string | null, city?: string | null, county?: string | null, postcode?: string | null, country?: string | null } | null, logo?: { __typename?: 'Image', src: string } | null, favicon?: { __typename?: 'Favicon', s16?: string | null, s32?: string | null, s180?: string | null, s192?: string | null, s512?: string | null } | null, socialImage?: { __typename?: 'Image', src: string } | null, social?: { __typename?: 'Social', facebook?: string | null, instagram?: string | null, linkedIn?: string | null, twitter?: string | null } | null } | null } };

export type UpdateSiteNavigationMutationVariables = Exact<{
  siteId: Scalars['String'];
  navigation: NavigationInput;
}>;


export type UpdateSiteNavigationMutation = { __typename?: 'Mutation', updateSiteNavigation: { __typename?: 'Site', _id: string, navigation?: { __typename?: 'Navigation', header?: Array<{ __typename?: 'NavItem', id: string, label: string, type: string, pageId?: string | null, url?: string | null, order: number, redirectToChild?: boolean | null, children?: Array<{ __typename?: 'NavItem', id: string, label: string, type: string, pageId?: string | null, url?: string | null, order: number, redirectToChild?: boolean | null }> | null }> | null, footer?: Array<{ __typename?: 'NavItem', id: string, label: string, type: string, pageId?: string | null, url?: string | null, order: number, redirectToChild?: boolean | null }> | null } | null, redirects?: Array<{ __typename?: 'UrlRedirect', from: string, to: string, createdAt: string }> | null } };

export type UpdateSiteRedirectsMutationVariables = Exact<{
  siteId: Scalars['String'];
  redirects: Array<UrlRedirectInput> | UrlRedirectInput;
}>;


export type UpdateSiteRedirectsMutation = { __typename?: 'Mutation', updateSiteRedirects: { __typename?: 'Site', _id: string, redirects?: Array<{ __typename?: 'UrlRedirect', from: string, to: string, createdAt: string }> | null } };

export type UpdateUserRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string } };

export type UserFieldsFragment = { __typename?: 'User', _id: string, email: string, name?: string | null, role: UserRole, siteIds: Array<string>, status: UserStatus, receiveDailyDigest: boolean, invitedAt?: string | null, createdAt: string, updatedAt: string };

export const ClientFragmentDoc = gql`
    fragment client on Client {
  name
  registeredName
  registered_number
  email
  phone
  contact_page
  contact_form
  blog_cta
  portal
  team_modal
  team_basic
  footer_text
  gtm
  contact {
    line1
    line2
    city
    county
    postcode
    country
  }
  logo {
    src
  }
  favicon {
    s16
    s32
    s180
    s192
    s512
  }
  socialImage {
    src
  }
  social {
    facebook
    instagram
    linkedIn
    twitter
  }
  bannerTitleWhite
}
    `;
export const DomainFragmentDoc = gql`
    fragment domain on Domain {
  _id
  domain
  redirectWww
  certificateArn
  ownsCert
  status
  statusError
  lastCheckedAt
  validationRecords {
    name
    value
    type
  }
  createdAt
  updatedAt
}
    `;
export const PartnerPageFragmentDoc = gql`
    fragment partnerPage on PartnerPage {
  _id
  description
  name
  published
  slug
  order
  thumbnail {
    lg
    md
    sm
    alt
  }
  title
  seoTitle
  content {
    layout
    title
    tagline
    bannerImage {
      lg
      md
      sm
      alt
    }
    main {
      blocks
    }
    sidebar {
      blocks
    }
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  _id
  email
  name
  role
  siteIds
  status
  receiveDailyDigest
  invitedAt
  createdAt
  updatedAt
}
    `;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($token: String!, $password: String!) {
  acceptInvite(token: $token, password: $password)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptInviteGQL extends Apollo.Mutation<AcceptInviteMutation, AcceptInviteMutationVariables> {
    override document = AcceptInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDomainDocument = gql`
    mutation CreateDomain($input: CreateDomainInput!) {
  createDomain(input: $input) {
    ...domain
  }
}
    ${DomainFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDomainGQL extends Apollo.Mutation<CreateDomainMutation, CreateDomainMutationVariables> {
    override document = CreateDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePartnerPageDocument = gql`
    mutation CreatePartnerPage($createPartnerPageInput: PartnerPageInput!) {
  createPartnerPage(createPartnerPageInput: $createPartnerPageInput) {
    ...partnerPage
  }
}
    ${PartnerPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePartnerPageGQL extends Apollo.Mutation<CreatePartnerPageMutation, CreatePartnerPageMutationVariables> {
    override document = CreatePartnerPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProfileDocument = gql`
    mutation CreateProfile($createProfileInput: ProfileInput!) {
  createProfile(createProfileInput: $createProfileInput) {
    _id
    name
    title
    text
    order
    image {
      src
    }
    social {
      facebook
      instagram
      linkedIn
      twitter
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProfileGQL extends Apollo.Mutation<CreateProfileMutation, CreateProfileMutationVariables> {
    override document = CreateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSiteDocument = gql`
    mutation CreateSite($createSiteInput: SiteInput!) {
  createSite(createSiteInput: $createSiteInput) {
    _id
    url
    client {
      ...client
    }
  }
}
    ${ClientFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSiteGQL extends Apollo.Mutation<CreateSiteMutation, CreateSiteMutationVariables> {
    override document = CreateSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($userId: String!) {
  deactivateUser(userId: $userId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateUserGQL extends Apollo.Mutation<DeactivateUserMutation, DeactivateUserMutationVariables> {
    override document = DeactivateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDomainDocument = gql`
    mutation DeleteDomain($id: ID!) {
  deleteDomain(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDomainGQL extends Apollo.Mutation<DeleteDomainMutation, DeleteDomainMutationVariables> {
    override document = DeleteDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePartnerPageDocument = gql`
    mutation DeletePartnerPage($id: String!) {
  deletePartnerPage(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePartnerPageGQL extends Apollo.Mutation<DeletePartnerPageMutation, DeletePartnerPageMutationVariables> {
    override document = DeletePartnerPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProfileDocument = gql`
    mutation DeleteProfile($id: String!) {
  deleteProfile(id: $id) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProfileGQL extends Apollo.Mutation<DeleteProfileMutation, DeleteProfileMutationVariables> {
    override document = DeleteProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSiteDocument = gql`
    mutation DeleteSite($id: String!) {
  deleteSite(id: $id) {
    _id
    url
    client {
      ...client
    }
  }
}
    ${ClientFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSiteGQL extends Apollo.Mutation<DeleteSiteMutation, DeleteSiteMutationVariables> {
    override document = DeleteSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DomainsDocument = gql`
    query Domains {
  domains {
    ...domain
  }
}
    ${DomainFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DomainsGQL extends Apollo.Query<DomainsQuery, DomainsQueryVariables> {
    override document = DomainsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DomainsIssuedDocument = gql`
    query DomainsIssued {
  domainsIssued {
    ...domain
  }
}
    ${DomainFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DomainsIssuedGQL extends Apollo.Query<DomainsIssuedQuery, DomainsIssuedQueryVariables> {
    override document = DomainsIssuedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArticleDocument = gql`
    query GetArticle($id: String!) {
  partnerPage(id: $id) {
    _id
    name
    title
    description
    slug
    published
    author
    authorTitle
    articleDate
    seoTitle
    byline
    type
    thumbnail {
      lg
      md
      sm
      alt
    }
    content {
      layout
      title
      tagline
      main {
        blocks
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArticleGQL extends Apollo.Query<GetArticleQuery, GetArticleQueryVariables> {
    override document = GetArticleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArticlesDocument = gql`
    query GetArticles($siteId: String!, $type: String) {
  partnerPages(siteId: $siteId, type: $type) {
    _id
    name
    title
    slug
    published
    author
    articleDate
    thumbnail {
      lg
      md
      sm
      alt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArticlesGQL extends Apollo.Query<GetArticlesQuery, GetArticlesQueryVariables> {
    override document = GetArticlesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnerPageDocument = gql`
    query GetPartnerPage($id: String!) {
  partnerPage(id: $id) {
    _id
    name
    title
    seoTitle
    description
    slug
    published
    policy
    hidden
    redirectToChild
    type
    author
    articleDate
    thumbnail {
      lg
      md
      sm
      alt
    }
    content {
      layout
      title
      tagline
      bannerImage {
        lg
        md
        sm
        alt
      }
      main {
        blocks
      }
      sidebar {
        blocks
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnerPageGQL extends Apollo.Query<GetPartnerPageQuery, GetPartnerPageQueryVariables> {
    override document = GetPartnerPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnerPageVersionsDocument = gql`
    query GetPartnerPageVersions($pageId: String!) {
  partnerPageVersions(pageId: $pageId) {
    _id
    pageId
    versionNumber
    snapshot
    note
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnerPageVersionsGQL extends Apollo.Query<GetPartnerPageVersionsQuery, GetPartnerPageVersionsQueryVariables> {
    override document = GetPartnerPageVersionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnerPagesDocument = gql`
    query GetPartnerPages($siteId: String!, $type: String) {
  partnerPages(siteId: $siteId, type: $type) {
    _id
    name
    title
    slug
    published
    policy
    hidden
    type
    author
    articleDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnerPagesGQL extends Apollo.Query<GetPartnerPagesQuery, GetPartnerPagesQueryVariables> {
    override document = GetPartnerPagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDocument = gql`
    query GetProfile($id: String!) {
  getProfileById(id: $id) {
    _id
    name
    firstName
    surname
    title
    text
    order
    image {
      src
    }
    social {
      facebook
      instagram
      linkedIn
      twitter
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileGQL extends Apollo.Query<GetProfileQuery, GetProfileQueryVariables> {
    override document = GetProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfilesDocument = gql`
    query GetProfiles($siteId: String!) {
  profiles(siteId: $siteId) {
    _id
    name
    firstName
    surname
    title
    text
    order
    image {
      src
    }
    social {
      facebook
      instagram
      linkedIn
      twitter
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfilesGQL extends Apollo.Query<GetProfilesQuery, GetProfilesQueryVariables> {
    override document = GetProfilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteDocument = gql`
    query GetSite($url: String!, $categoryId: String!) {
  site(url: $url, categoryId: $categoryId) {
    _id
    url
    client {
      ...client
    }
    menus {
      id
      links {
        title
        slug
        menu_order
      }
      name
      slug
    }
  }
}
    ${ClientFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteGQL extends Apollo.Query<GetSiteQuery, GetSiteQueryVariables> {
    override document = GetSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteNavigationDocument = gql`
    query GetSiteNavigation($url: String!, $categoryId: String!) {
  site(url: $url, categoryId: $categoryId) {
    _id
    url
    menus {
      id
      name
      slug
      links {
        title
        slug
        url
      }
    }
    navigation {
      header {
        id
        label
        type
        pageId
        url
        order
        redirectToChild
        children {
          id
          label
          type
          pageId
          url
          order
          redirectToChild
        }
      }
      footer {
        id
        label
        type
        pageId
        url
        order
        redirectToChild
      }
    }
    redirects {
      from
      to
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteNavigationGQL extends Apollo.Query<GetSiteNavigationQuery, GetSiteNavigationQueryVariables> {
    override document = GetSiteNavigationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSiteRedirectsDocument = gql`
    query GetSiteRedirects($url: String!, $categoryId: String!) {
  site(url: $url, categoryId: $categoryId) {
    _id
    redirects {
      from
      to
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSiteRedirectsGQL extends Apollo.Query<GetSiteRedirectsQuery, GetSiteRedirectsQueryVariables> {
    override document = GetSiteRedirectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSitesDocument = gql`
    query GetSites {
  sites {
    _id
    url
    domainId
    client {
      ...client
    }
  }
}
    ${ClientFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSitesGQL extends Apollo.Query<GetSitesQuery, GetSitesQueryVariables> {
    override document = GetSitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query GetUsers($siteId: String!) {
  users(siteId: $siteId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    override document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteUserDocument = gql`
    mutation InviteUser($input: InviteUserInput!) {
  inviteUser(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteUserGQL extends Apollo.Mutation<InviteUserMutation, InviteUserMutationVariables> {
    override document = InviteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query Me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    override document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshDomainStatusDocument = gql`
    mutation RefreshDomainStatus($id: ID!) {
  refreshDomainStatus(id: $id) {
    ...domain
  }
}
    ${DomainFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshDomainStatusGQL extends Apollo.Mutation<RefreshDomainStatusMutation, RefreshDomainStatusMutationVariables> {
    override document = RefreshDomainStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReorderProfilesDocument = gql`
    mutation ReorderProfiles($input: [ReorderProfileInput!]!) {
  reorderProfiles(input: $input) {
    _id
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReorderProfilesGQL extends Apollo.Mutation<ReorderProfilesMutation, ReorderProfilesMutationVariables> {
    override document = ReorderProfilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInviteDocument = gql`
    mutation ResendInvite($userId: String!) {
  resendInvite(userId: $userId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInviteGQL extends Apollo.Mutation<ResendInviteMutation, ResendInviteMutationVariables> {
    override document = ResendInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevertPartnerPageDocument = gql`
    mutation RevertPartnerPage($id: String!, $versionNumber: Int!) {
  revertPartnerPage(id: $id, versionNumber: $versionNumber) {
    ...partnerPage
  }
}
    ${PartnerPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevertPartnerPageGQL extends Apollo.Mutation<RevertPartnerPageMutation, RevertPartnerPageMutationVariables> {
    override document = RevertPartnerPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleDailyDigestDocument = gql`
    mutation ToggleDailyDigest($userId: String!, $receive: Boolean!) {
  toggleDailyDigest(userId: $userId, receive: $receive) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleDailyDigestGQL extends Apollo.Mutation<ToggleDailyDigestMutation, ToggleDailyDigestMutationVariables> {
    override document = ToggleDailyDigestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePartnerPageDocument = gql`
    mutation UpdatePartnerPage($id: String!, $updatePartnerPageInput: PartnerPageInput!) {
  updatePartnerPage(id: $id, updatePartnerPageInput: $updatePartnerPageInput) {
    ...partnerPage
  }
}
    ${PartnerPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePartnerPageGQL extends Apollo.Mutation<UpdatePartnerPageMutation, UpdatePartnerPageMutationVariables> {
    override document = UpdatePartnerPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($id: String!, $updateProfileInput: ProfileInput!) {
  updateProfile(id: $id, updateProfileInput: $updateProfileInput) {
    _id
    name
    title
    text
    order
    image {
      src
    }
    social {
      facebook
      instagram
      linkedIn
      twitter
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfileGQL extends Apollo.Mutation<UpdateProfileMutation, UpdateProfileMutationVariables> {
    override document = UpdateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSiteDocument = gql`
    mutation UpdateSite($id: String!, $updateSiteInput: SiteInput!) {
  updateSite(id: $id, updateSiteInput: $updateSiteInput) {
    _id
    url
    client {
      ...client
    }
  }
}
    ${ClientFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSiteGQL extends Apollo.Mutation<UpdateSiteMutation, UpdateSiteMutationVariables> {
    override document = UpdateSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSiteNavigationDocument = gql`
    mutation UpdateSiteNavigation($siteId: String!, $navigation: NavigationInput!) {
  updateSiteNavigation(siteId: $siteId, navigation: $navigation) {
    _id
    navigation {
      header {
        id
        label
        type
        pageId
        url
        order
        redirectToChild
        children {
          id
          label
          type
          pageId
          url
          order
          redirectToChild
        }
      }
      footer {
        id
        label
        type
        pageId
        url
        order
        redirectToChild
      }
    }
    redirects {
      from
      to
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSiteNavigationGQL extends Apollo.Mutation<UpdateSiteNavigationMutation, UpdateSiteNavigationMutationVariables> {
    override document = UpdateSiteNavigationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSiteRedirectsDocument = gql`
    mutation UpdateSiteRedirects($siteId: String!, $redirects: [UrlRedirectInput!]!) {
  updateSiteRedirects(siteId: $siteId, redirects: $redirects) {
    _id
    redirects {
      from
      to
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSiteRedirectsGQL extends Apollo.Mutation<UpdateSiteRedirectsMutation, UpdateSiteRedirectsMutationVariables> {
    override document = UpdateSiteRedirectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($input: UpdateUserRoleInput!) {
  updateUserRole(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserRoleGQL extends Apollo.Mutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables> {
    override document = UpdateUserRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }